export const firstInArray = (el) => el === 0;

export const lastInArray = (el, arrLength) => el === arrLength - 1;

export const isNotUndefined = (el) => typeof el !== 'undefined';

export const isPositive = (val) => val >= 0;

export const isNegative = (val) => val < 0;

export const emptyArray = (count, fill) => Array(count).fill(fill);

export const findFirstMatch = (arr, condition) => arr.filter(condition)[0];

/**
 * Outputs input value.
 */
export const identity = (value) => value;
